import type { MatchConfig } from '../proto';
import type { GameId } from '../wasm';
import type { CpuLevel } from '../wasm/cpu';
import { gameIconSlug } from './game-meta';
import { navigate } from './navigate';

/** Same single-board defaults as the CPU setup screen. */
export function singleGameCpuConfig(game: GameId): MatchConfig {
  return {
    template: `preset:${game === 'AnimalShogi' ? 'animal' : gameIconSlug(game)}`,
    games: [game],
    orchestrator: 'Sequential',
    clock: {
      scope: 'Whole',
      increment: { type: 'Fischer', increment_ms: 3000 },
      initial_ms: 2 * 60 * 60 * 1000,
    },
    win: { kind: 'MajorityOfBoards' },
    auto_finish: false,
  };
}

/** Persist a fresh local match before navigating; existing matches stay available. */
export function startCpuMatch(config: MatchConfig, cpuLevel: CpuLevel): void {
  const id = typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID().slice(0, 8)
    : Math.random().toString(36).slice(2, 10);
  localStorage.setItem(
    `mixed-game.local.setup.${id}`,
    JSON.stringify({ config, cpuLevel, yourRolePreference: 'random' }),
  );
  navigate(`/local/${id}`);
}
